import React from 'react';
import ArticleDeliveryRowProperties from "./ArticleDeliveryRowProperties";
import ViewMedium from "../../../ui_components/MediaView/ViewMedium";
import ArticleDeliveryRowMedium from "./ArticleDeliveryRowMedium";
import ViewLarge from "../../../ui_components/MediaView/ViewLarge";
import ViewSmall from "../../../ui_components/MediaView/ViewSmall";
import ArticleDeliveryRowSmall from "./ArticleDeliveryRowSmall";


const ArticleDeliveryRow: React.FC<ArticleDeliveryRowProperties> = ({
                                                                    articleDeliveryOrder,
                                                                    selectedDeliveryOrderIds,
                                                                    onArticleDeliveryOrderClick,
                                                                    onArticleDeliveryOrderSelect,
                                                                    onDeliveryFlowSelect,
                                                                    onContactSelect,
                                                                    onUpdate,
                                                                    filter,
                                                                    from,
                                                                    to,
                                                                }) => {
    return (
        <>
            <ViewSmall>
                <ArticleDeliveryRowSmall onUpdate={onUpdate} onArticleDeliveryOrderSelect={onArticleDeliveryOrderSelect}
                                       onArticleDeliveryOrderClick={onArticleDeliveryOrderClick}
                                       onDeliveryFlowSelect={onDeliveryFlowSelect}
                                       onContactSelect={onContactSelect}
                                       articleDeliveryOrder={articleDeliveryOrder}
                                       selectedDeliveryOrderIds={selectedDeliveryOrderIds}
                                       filter={filter} from={from} to={to}/>
            </ViewSmall>
            <ViewMedium>
                <ArticleDeliveryRowMedium onUpdate={onUpdate} onArticleDeliveryOrderSelect={onArticleDeliveryOrderSelect}
                                        onArticleDeliveryOrderClick={onArticleDeliveryOrderClick}
                                        onDeliveryFlowSelect={onDeliveryFlowSelect}
                                        onContactSelect={onContactSelect}
                                        articleDeliveryOrder={articleDeliveryOrder}
                                        selectedDeliveryOrderIds={selectedDeliveryOrderIds}
                                        filter={filter} from={from} to={to}/>
            </ViewMedium>
            <ViewLarge>
                <ArticleDeliveryRowMedium onUpdate={onUpdate} onArticleDeliveryOrderSelect={onArticleDeliveryOrderSelect}
                                        onArticleDeliveryOrderClick={onArticleDeliveryOrderClick}
                                        onDeliveryFlowSelect={onDeliveryFlowSelect}
                                        onContactSelect={onContactSelect}
                                        articleDeliveryOrder={articleDeliveryOrder}
                                        selectedDeliveryOrderIds={selectedDeliveryOrderIds}
                                        filter={filter} from={from} to={to}/>
            </ViewLarge>
        </>
    )
}

export default ArticleDeliveryRow;
